import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationEN from '../../locales/frontend/en-US/translation.json'
import translationEN_GB from '../../locales/frontend/en-GB/translation.json'
import translationPT from '../../locales/frontend/pt-PT/translation.json'
import translationAR from '../../locales/frontend/ar-SA/translation.json'
import translationHE from '../../locales/frontend/he-IL/translation.json'

const resources = {
  'en-US': {
    translation: translationEN,
  },
  'en-GB': {
    translation: translationEN_GB,
  },
  'pt-PT': {
    translation: translationPT,
  },
  'ar-SA': {
    translation: translationAR,
  },
  'he-IL': {
    translation: translationHE,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en-US', // Default language
    fallbackLng: 'en-US', // Fallback language
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false,
    },
    
    // Add debug mode to see what's happening
    debug: false,
    
    // Ensure translations are loaded synchronously
    initImmediate: false,
  })

export default i18n 